import { MetalsTask } from "../models/metals-task.model";

export function findRootTasks(tasks: MetalsTask[]): MetalsTask[] {
	const idToInDegree = new Map<string, number>();

	tasks.forEach(task => {
		idToInDegree.set(task.id, 0);
	});

	tasks.forEach(task => {
		if (task.nextTaskId !== null) {
			const currentDegree = idToInDegree.get(task.nextTaskId) || 0;
			idToInDegree.set(task.nextTaskId, currentDegree + 1);
		}
	});

	return tasks.filter(task =>
		idToInDegree.get(task.id) === 0
	);
}